import css from '../tpl-css/style-section-markqueue-kynorelle.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  id="card-container-unique-id"
  data-id="unique-id"
  data-background="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#ffffff"
  style="background-color: #ffffff; color: #ffffff; --text-color: #ffffff;"
>
  <div
    class="container-markqueue"
    data-attribute="container-markqueue"
    data-background-markqueue="#003568"
    style="background-color: #003568; --background-color-markqueue: #003568;"
  >
    <div data-attribute="block-markqueue" class="block-markqueue">
      <div data-attribute="item-markqueue" class="item-markqueue">
        <div class="icon-item">
          <img
            data-attribute="icon-item-markqueue"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item-markqueue" class="text-item">
          No squeeze. No adjust. Just moves with you.
        </div>
      </div>
      <div data-attribute="item-markqueue" class="item-markqueue">
        <div class="icon-item">
          <img
            data-attribute="icon-item-markqueue"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item-markqueue" class="text-item">
          No squeeze. No adjust. Just moves with you.
        </div>
      </div>
      <div data-attribute="item-markqueue" class="item-markqueue">
        <div class="icon-item">
          <img
            data-attribute="icon-item-markqueue"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9c4b7a23628bae9c6b0.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item-markqueue" class="text-item">
          No squeeze. No adjust. Just moves with you.
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
